import { get, merge } from "lodash"

export const Config = {
  app: {
    // 代行ログインモード
    isAgency: false,
    FileDownloadName: {
      PositionView: "PositionView.csv",
      OrderInquiry: "OrderInquiry.csv",
      TradeHistory: "TradeHistory.csv",
      TradeHistoryList: "TradeHistoryList.csv",
      TransferMoney: "TransferMoney.csv",
      Billing: "DepositFlow.csv",
      ReceiveMarginHistory: "AcceptedMarginHistory.csv",
      RevenueReferenceYearly: {
        3: "ProfitSummary.pdf",
        5: "ProfitSummaryTFX_FX.pdf",
        6: "ProfitSummaryTFX_CFD.pdf",
      },
      TradeReport: {
        5: "TradeReportTFX_FX.pdf",
        6: "TradeReportTFX_CFD.pdf",
      },
      CashFlowStatement: {
        5: "CashFlowStatementTFX_FX.pdf",
        6: "CashFlowStatementTFX_CFD.pdf",
      },
      MonthReport: {
        5: "MonthReportTFX_FX.pdf",
        6: "MonthReportTFX_CFD.pdf",
      },
    },
    Notification: {
      ReferenceTypes: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    },
  },
  api: {
    // rootUrl: "http://aifront01.internal.tworkscloud.com/Api/",
    rootUrl: "https://www.ai.tworkscloud.com/Api/", //(本番用)
    version: "1.0",
    account: "",
    dummy_push: false,
    disabled_push: false,
    stub: true,
    auth: {
      key: "12345678901234567890123456789012",
      iv: "",
      WebRichLogin: "RB_NormalUser",
      openLogin: "RC_OpenUser",
      WebRichLoginPw: "123456",
      UserStorage: "7078b62c81e497aec611998178ecaacd",
      AgencyLogin: "WR_Operator",
      AgencyLoginPw: "123456",
    },
    SSO: {
      WR_SSOUser: "123456",
      WR_SSOMarket: "123456",
      WR_SSOBoard: "123456",
      WR_SSOChart: "123456",
      WR_SSOOrder: "123456",
    },
    // push_delay: push_delay, // 受けたまんまを流すとActionが発行されまくって(特にreg/unregで切り替える瞬間)パフォーマンスに影響があるので、一定間隔で来たメッセージを一纏めにする
    NodeDistURL: "http://aifront01:8080/", // PUSH通知用のURL
    // NodeDistURL: "https://www.ai.tworkscloud.com:8080/", // PUSH通知用のURL(本番用)
    delayGetWalletTime: 1000,
    cacheTimeInterval: 1000,
    checkSessionPollingInterval: 60000,
    rankingPollingInterval: 300 * 1000,
    boardTargetExchangePollingInterval: 60000, //先物OPボード用
    tickerPollingInterval: 5 * 1000, //ヘッダー部のTicker用
    searchDebounceTime: 300, //指定された時間経過後に検索実行 連続でAPIコール防止用
    delayCallPollingAction: 200, //pollingCacheOutで呼ぶActionを不可対策のため、設定値msの中でランダムにmsを作り、ユーザーごとにわずかにタイミングをずらしている値
    iframeTargetOrigin: "http://wp-aizawa-demo.mobaji.jp/market/index.html", //オフィシャルサイトに埋め込むiframeのURL(TODO:まだ仮のURLなので配置場所決まり次第変更していく)
    iframeTargetOriginHome: "http://wp-aizawa-demo.mobaji.jp/", //オフィシャルサイトに埋め込むiframeのURL(TODO:まだ仮のURLなので配置場所決まり次第変更していく)
  },
  order: {
    // 発注画面のユーザー設定
    defaultSettings: {
      autoLoad: true,
    },
  },
  board: {
    divisionStatisticTimeout: 900, //秒=15分
  },
  // ビリングに関しては全てテスト用パラメータ
  billing: {
    ResultUrl:
      window.location.origin +
      window.location.pathname +
      "BillingResult/Success",
    ResultUrlFail:
      window.location.origin + window.location.pathname + "BillingResult/Fail",
  },
  debug: true,
}

if (process.env.NODE_ENV === "development") {
  const debugConfig = {
    debugConfig: {
      TestNodeDistURL: "http://dmfront04:3000",
    },
  }
  merge(Config, debugConfig)
  merge(Config, get(window, "ext_config_dev", {}))
} else if (get(window, "ext_config", false)) {
  merge(Config, get(window, "ext_config", {}))
}
export const config = Config
